import { useState, useRef } from "react";
import { Box, Button } from "@mui/material";
import { CloudArrowUpIcon } from "@heroicons/react/24/outline";
import { dataSyncService } from "features/dataSync/services/data-sync-service";

import { buttonsRowStyle } from "./styles";

export const UploadSyncFile = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [abortController, setAbortController] = useState<AbortController | null>(null);

  const handleUploadFile = async (file: File) => {
    setIsProcessing(true);

    try {
      const controller = new AbortController();
      setAbortController(controller);
      await dataSyncService.uploadNativeLangFile(file, controller);
    } catch (error) {
      console.error(error);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event?.target?.files?.[0];
    if (file) {
      handleUploadFile(file);
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onCancelClick = () => {
    if (abortController) {
      abortController.abort();
      setAbortController(null);
    }
  };

  return (
    <>
      <p>Upload zip file with only native language files to update database.</p>
      <Box sx={buttonsRowStyle}>
        <Button
          component="label"
          role={undefined}
          variant="contained"
          tabIndex={-1}
          startIcon={<CloudArrowUpIcon width={20} height={20} />}
          disabled={isProcessing}
        >
          Upload synchronization file
          <input type="file" accept=".zip" ref={fileInputRef} style={{ display: "none" }} onChange={handleFileChange} />
        </Button>
      </Box>
    </>
  );
};
